if (jQuery('html').hasClass('ie')) {
    // jQuery('img').each(function(){
    //     var datasrc = 0;
    //     datasrc = jQuery(this).attr('data-src');
    //     if ( datasrc ) {
    //         jQuery(this).attr('src', datasrc);
    //     }
    // });
    jQuery('.lozad').each(function(){
        var datasrc = 0;
        datasrc = jQuery(this).attr('data-src');
        if ( datasrc ) {
            jQuery(this).attr('src', datasrc);
        }
        var databg = 0;
        databg = jQuery(this).attr('data-background-image');
        if ( databg ) {
            jQuery(this).css('background-image', 'url('+databg+')');
        }
    });
}


